module.exports = __webpack_public_path__ + "resources/img/logo_partner_public_3.114360bc433db8f6e2130da744631d3b.png";